import {AddTagControlMinimalType} from "@twigsby/client-data/lib/Types/UKPBTagTypes";
import {
    ComboBoxControl, ContentBlock,
    ContentLoader,
} from "@twigsby/frontend-framework";
import {FormProvider, useForm} from "@twigsby/frontend-framework/lib/ReactHookForm";
import useTagManger from "../../Hooks/useTagManger";
import React, {useEffect} from "react";
import {useMailbox} from "../../Providers/NewMailboxProvider";

export interface AddTagControlUiType extends AddTagControlMinimalType {
    indeterminateTags?: Array<any>;
    menuToggled?: boolean;
    dataKey: any;
    listInMenu?: boolean;
    autoFocus?: boolean;
}

const AddTagControl = (props: AddTagControlUiType) => {
    const { userFilters, data, mailItemData, selectedItems } = useMailbox();
    const formMethods = useForm();

    const {
        selectShapedData,
        selectionTags,
        selectionIndeterminateTags,
        tagStatus,
        tagError,
        isFetchingNextTagPage,
        fetchNextTagPage,
        hasNextTagPage,
        tagItemCounts,
        CreateTag,
        FilterTags
    } = useTagManger();


    const HandleCreate = (value: any) => {
        CreateTag(value).then((r) => {
            props.updateCallback({label: r.name , value: r.id }, true);
        })
    }

    const HandleChange = (e: any, checked: boolean) => {
        props.updateCallback(e, checked);
    }

    const HandleAllChanged = (e: boolean) => {
        console.log('HandleAllChanged', e);
        selectShapedData.forEach((tag) => {
            props.updateCallback(tag, e);
        });
    }

    useEffect(() => {
        if(Object.keys(userFilters).length > 0) {
            FilterTags(mailItemData, [mailItemData?.mailUuid]);
        } else {
            FilterTags(data, selectedItems);
        }
    }, [props, userFilters]);

    return (
        <>
            {tagStatus === "loading" ? (
                <ContentLoader />
            ) : tagStatus === "error" ? (
                <ContentBlock error={true} title={tagError?.name as string} content={tagError?.message} />
            ) : (
                <FormProvider {...formMethods}>
                    <ComboBoxControl
                        name={'addTags'}
                        placeholder={'Filter Tags...'}
                        data={selectShapedData}
                        forwardItemCallback={(e, checked) => HandleChange(e, checked)}
                        forwardSelectAllCallback={(e) => HandleAllChanged(e)}
                        defaultValues={selectionTags}
                        indeterminateValues={selectionIndeterminateTags}
                        loading={selectShapedData.length === 0}
                        listAlwaysVisible={props.listAlwaysVisible}
                        valueType={'number'}
                        listInMenu={props.listInMenu}
                        isFetchingNextPage={isFetchingNextTagPage}
                        fetchNextPage={fetchNextTagPage}
                        hasNextPage={hasNextTagPage}
                        itemCounts={tagItemCounts}
                        hideArrow={true}
                        emptyResultCallback={(value: any) => HandleCreate(value)}
                        autoFocusFilter={true}
                        clearOnClose={true}
                    />
                </FormProvider>
            )}
        </>
    )
}

export default AddTagControl
